import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navbar from './components/global/Navbar';
import Footer from './components/global/Footer';
import Home from './pages/Home';       // your existing landing page content
import About from './pages/About';
import Products from './pages/Products';
import Admin from './pages/Admin';
import Blog     from './pages/Blog';
import BlogPost from './components/blog/BlogPost';
import { CartProvider } from './context/CartContext';
import { FavouritesProvider } from './context/FavouritesContext';
import CartDrawer from './components/cart/CartDrawer';
import Checkout from './components/cart/Checkout';
import FavouritesPage from './components/favourites/FavouritesPage';

export default function App() {
  return (
    <BrowserRouter>
      <CartProvider>
        <FavouritesProvider>
          <Routes>
            <Route path="/nw-admin-9x7k" element={<Admin />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/*" element={
              <>
                <Navbar />
                <CartDrawer />
                <Routes>
                  <Route path="/"         element={<Home />} />
                  <Route path="/about"    element={<About />} />
                  <Route path="/products" element={<Products />} />
                  <Route path="/blog"     element={<Blog />} />
                  <Route path="/blog/:slug" element={<BlogPost />} />
                  <Route path="/favourites" element={<FavouritesPage />} />
                </Routes>
                <Footer />
              </>
            } />
          </Routes>
        </FavouritesProvider>
      </CartProvider>
    </BrowserRouter>
  );
}